import { Component, ViewChild } from '@angular/core';
import { faSearch, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { IncidentsService } from 'src/app/services/incidents.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, of } from 'rxjs';
import { ReportComponent } from 'src/app/components/report/report.component';
import { IncidentInfoComponent } from 'src/app/components/incident-info/incident-info.component';
import { HandlerSnackbarService } from 'src/app/services/handler-snackbar.service';

@Component({
  selector: 'app-incidents',
  templateUrl: './incidents.component.html',
  styleUrls: ['./incidents.component.scss'],
})
export class IncidentsComponent {
  faSearch = faSearch;
  faCircleInfo = faCircleInfo;
  tab: string = 'pending';
  dataSource$: Observable<any> | undefined = this.getPendingList();
  dataSource: any;
  @ViewChild(MatSort) sortPending = new MatSort();
  @ViewChild(MatSort) sortHistory = new MatSort();
  displayedColumnsPending: string[] = [
    'incidentId',
    'submittedAt',
    'oggetto',
    'note',
    'details',
  ];
  displayedColumnsHistory: string[] = [
    'incidentId',
    'submittedAt',
    'oggetto',
    'note',
    'noteChiusura',
    'resolvedAt',
    'details',
  ];

  constructor(
    private readonly service: IncidentsService,
    private readonly modalService: NgbModal,
    private readonly alertService: HandlerSnackbarService,
    private readonly utilities: UtilitiesService,
    private readonly spinnerService: SpinnerService
  ) {}

  getPendingList() {
    this.spinnerService.open();
    return this.service.pendingIncidents$.pipe(
      catchError((error: HttpErrorResponse) => {
        return this.alertService.handlerErrorSubscribe(error);
      }),
      map((data: any) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sort = this.sortPending;
        this.dataSource.sortingDataAccessor = (item: any, property: string) => {

          if (property == "submittedAt") return this.utilities.transformDate(item.submittedAt);
          return item[property];
        };
        this.spinnerService.close();
        return this.dataSource;
      })
    );
  }

  getHistoryList() {
    this.spinnerService.open();
    return this.service.getHistoryIncidents().pipe(
      catchError((error: HttpErrorResponse) => {
        this.alertService.viewUserClosingMessage(
          error.error?.error?.message || error.error?.message || error.message,
          'error-snackbar'
        );
        return of(undefined);
      }),
      map((data: any) => {
        this.dataSource = new MatTableDataSource(data);
        this.dataSource.sort = this.sortHistory;
        this.dataSource.sortingDataAccessor = (item: any, property: string) => {
          switch (property) {
            case 'submittedAt':
              return this.utilities.transformDate(item.submittedAt);
            case 'resolvedAt':
              return this.utilities.transformDate(item.resolvedAt);
            default:
              return item[property];
          }
        };
        this.spinnerService.close();
        return this.dataSource;
      })
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  tabChange(selTab: string) {
    this.tab = selTab;
    switch (selTab) {
      case 'pending':
        this.service.getPendingIncidents();
        this.dataSource$ = this.getPendingList();
        break;
      case 'history':
        this.dataSource$ = this.getHistoryList();
        break;
      default:
        this.spinnerService.close();
    }
  }

  newIncidentModal() {
    const modalRef = this.modalService.open(ReportComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          this.alertService.viewUserMessage();
          this.spinnerService.open();
          this.service
            .createIncident(result)
            .pipe(
              catchError((error: HttpErrorResponse) => {
                this.spinnerService.close();
                this.getPendingList();
                return this.alertService.handlerErrorSubscribe(error);
              })
            )
            .subscribe((data: any) => {
              this.service.getPendingIncidents();
              this.spinnerService.close();
              this.alertService.viewUserClosingMessage(
                'Segnalazione inviata con successo',
                'success-snackbar'
              );
              this.getPendingList();
            });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  infoModal(element: any) {
    const modalRef = this.modalService.open(IncidentInfoComponent, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
    });
    modalRef.componentInstance.incidentId = element.incidentId;
  }
}
